import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef, ViewContainerRef, EmbeddedViewRef, TemplateRef, OnDestroy } from '@angular/core';
import * as Highcharts from 'highcharts';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Location } from '@angular/common';
import html2canvas from 'html2canvas';
//import html2canvas from 'html2canvas';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

declare var require: any;
//require('highcharts/modules/map')(Highcharts);
if (typeof Highcharts === 'object') {

  let Boost = require('highcharts/modules/boost');
  let noData = require('highcharts/modules/no-data-to-display');
  let More = require('highcharts/highcharts-more');

  Boost(Highcharts);
  noData(Highcharts);
  More(Highcharts);
  noData(Highcharts);
}
//const mapUS = require('@highcharts/map-collection/countries/us/us-all.geo.json');

import { AnalyticsService } from '../../shared/providers/analytics.service';
import { ValidationService } from '../../shared/providers/validation.service';
import { ToastService } from '../../shared/providers/toast.service';
import { CommonService } from '../../shared/providers/common.service';
import { LoaderService } from '../../shared/providers/loader.service';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { PropertyListingService } from '../../shared/providers/property-listing.service';

import { IPropertySearchCriteria } from '../../shared/models/propertysearchcriteria';
import { DataTablesResponse } from '../../shared/models/datatables-response';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment'
import { IPropertyCard } from '../../shared/models/propertycard';
import { Subject, Subscription } from 'rxjs';
import { SaveAnalyticsInputModel } from '../../shared/models/SavePropertyAnalyitcsInputModel';
import { ISaveSearchInputModel } from '../../shared/models/SaveSearchInputModel';

//declare module 'googlemaps';
//declare var MarkerClusterer: any;

interface IMapData {
  code: string;
  value: number;
  color: string;
  borderColor: string;
  borderWidth: number;
}

interface IChartInput {
  TenantId: number;
  StartDate: Date;
  EndDate: Date;
  States: string[];
  PropertyType: number;
  Subcategory: number;
  PropertyId: number;
  Mode?: number;
  Id: number[];
  Type?: number;
  PropertyTypes: number[];
  Subcategories: number[];
}

interface IPropertyData {
  Id: number;
  Name: string;
  Type: number;
}

interface IAnalyticsDetails {
  Name: string;
  Value: string;
}

//interface IPropertyDates {
//  DateOnMarket: Date;
//  CreatedDate: Date;
//}

enum Tabs {
  Listings = 1,
  MarketDataSummary = 2,
  SavedAnalytics = 3
}

@Component({
  selector: 'app-analytics-page',
  templateUrl: './analytics-page.component.html',
  styleUrls: ['./analytics-page.component.css']
})
export class AnalyticsPageComponent implements OnInit, OnDestroy {

  @ViewChild('map', { static: true }) mapContainer: ElementRef;
  @ViewChild('#map', { read: ViewContainerRef }) mapContainerRef: ViewContainerRef;
  @ViewChild('mapcard', { read: TemplateRef }) mapCardTemplate: TemplateRef<any>;
  @Output() boundsChanged = new EventEmitter<google.maps.LatLngBounds>();
  private markers: google.maps.Marker[] = [];
  private mapEx: google.maps.Map;
  private markerCluster: MarkerClusterer;
  private selectedMarker: google.maps.Marker;
  private currentInfoWindow: EmbeddedViewRef<any>;
  private infoWindow: google.maps.InfoWindow;
  private activeWindow: google.maps.InfoWindow;
  latFromValue: number = 20.00;
  latToValue: number = 50.00;
  longFromValue: number = -110.00;
  longToValue: number = -80.00;
  selectedDatapoint: boolean = false;
  savedAnalytics: boolean = false;

  dtTrigger = new Subject();
  public options: any = {}
  public barActiveListingAskingPrice: any = {}
  public barAskingPriceCapRate: any = {}
  public barRemainingTermCapRate: any = {}

  public LineNoOnMarket: any = {}
  public LineAverageCapRate: any = {}
  public LineAveragePrice: any = {}
  public LineAverageRemainingTerm: any = {}

  public barChart2: any = {}
  public pieChart: any = {}
  public barSubcategory: any = {}

  selectedStatesList = [];
  data: IMapData[];
  propertyData: any;
  chartInput = {} as IChartInput;
  colors = ["#28A436", "#EC5555", "#F2BD66", "#5BC8AF", "#198fde", "#8647B3", "#e47220", "#28A436", "#EC5555", "#F2BD66", "#5BC8AF", "#198fde", "#8647B3", "#e47220"];
  propertyTypesList: any;
  subCategoriesList: any;
  isState: boolean = false;
  isActiveListing: boolean = true;
  isRemainingTerm: boolean = true;
  isSCActiveListing: boolean = true;
  PropertyTypeText: string = '';
  SubcategoryText: string = '';
  isFilteredData = false;
  modalRef: BsModalRef;
  modalRefDelete: BsModalRef;
  analyticsDetails: any;
  minDate = null;
  maxDate = new Date();
  propertyDates: any;
  tabs = Tabs;
  dtOptions1 = {};
  private _subscriptions: Subscription[] = [];
  dtOptions = {};
  showSearch = false;
  tenantName: string = '';
  clearSaved = false;
  showAnalyticsGraphs = false;
  @Input() searchCriteria: IPropertySearchCriteria;
  saveAnalyticsInput = {} as SaveAnalyticsInputModel;
  savedAnalyticsData: any = [];
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  showAnalyzeBtn = true;
  markerIcon = 'assets/img/map-icon.sm.png';
  selectedMarkerIcon = 'assets/img/map-icon.sm-green.png';
  isAnalyzeName = false;
  DeleteGuid = null;
  expandedMap = false;
  constructor(private Analytics: AnalyticsService, public Validation: ValidationService, private Toast: ToastService, private router: Router, private common: CommonService,
    private activatedRoute: ActivatedRoute, private Loader: LoaderService, protected http: HttpClient,
    private _location: Location, private _toastService: ToastService, private modalService: BsModalService, public authService: AuthenticationService, protected _propertyListingService: PropertyListingService) {

  }
  pageLoad = false;
  ngOnInit() {
    //pdfMake.vfs = pdfFonts.pdfMake?.vfs;
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params['Guid']) {
        this.savedAnalytics = true;
        this.LoadData(params['Guid']);
      }
      else {
        this.LoadData(null);
      }
    });
    //this.LoadData();
  }

  ngOnDestroy() {
    this._subscriptions.forEach(sub => sub.unsubscribe());
  }

  propertySearchCriteria2(searchParameters: IPropertySearchCriteria) {
    this.searchCriteria = searchParameters;
    const searchCriteria: IPropertySearchCriteria = {
      Address: this.searchCriteria.Address,
      AssetTypes: this.searchCriteria.AssetTypes,
      Ratings: this.searchCriteria.Ratings,
      PriceFrom: this.searchCriteria.PriceFrom,
      PriceTo: this.searchCriteria.PriceTo,
      SkipCount: 0,
      SortValue: this.searchCriteria.SortValue,
      TakeCount: 50,
      Tenants: this.searchCriteria.Tenants,
      Terms: this.searchCriteria.Terms,
      IsMapView: false,
      Guid: this.searchCriteria.Guid,
      NOIFrom: this.searchCriteria.NOIFrom,
      NOITo: this.searchCriteria.NOITo,
      BuildingSizeFrom: this.searchCriteria.BuildingSizeFrom,
      BuildingSizeTo: this.searchCriteria.BuildingSizeTo,
      YearBuiltFrom: this.searchCriteria.YearBuiltFrom,
      YearBuiltTo: this.searchCriteria.YearBuiltTo,
      StateId: this.searchCriteria.StateId ? this.searchCriteria.StateId[0] : null,
      LeaseStructures: this.searchCriteria.LeaseStructures,
      CapRateFrom: this.searchCriteria.CapRateFrom,
      CapRateTo: this.searchCriteria.CapRateTo,
      PropertyStatus: this.searchCriteria.PropertyStatus,
      SubCategories: this.searchCriteria.SubCategories,
      IsRentAmount: this.searchCriteria.IsRentAmount,
      RentFrom: this.searchCriteria.RentFrom,
      RentTo: this.searchCriteria.RentTo,
      OwnershipTypes: this.searchCriteria.OwnershipTypes,
      IsExcludeSoldListing: this.searchCriteria.IsExcludeSoldListing,
      IsOnlySoldListing: this.searchCriteria.IsOnlySoldListing,
      IsExcludeContractListing: this.searchCriteria.IsExcludeContractListing,
      IsOnlyFeaturedListing: this.searchCriteria.IsOnlyFeaturedListing,
      LoggedInUserId: this.searchCriteria.LoggedInUserId,
      IsFavorite: this.searchCriteria.IsFavorite,
      PropertyFor: this.searchCriteria.PropertyFor,
      IsComp: this.searchCriteria.IsComp,
      IsArchive: this.searchCriteria.IsArchive,
      IsDisliked: this.searchCriteria.IsDisliked,
      IsSearchButtonClicked: this.searchCriteria.IsSearchButtonClicked,
      MinTerm: this.searchCriteria.MinTerm,
      MaxTerm: this.searchCriteria.MaxTerm,
      Brokerages: this.searchCriteria.Brokerages,
      States: this.searchCriteria.States,
      CharacteristicsId: this.searchCriteria.CharacteristicsId,
      AddressType: this.searchCriteria.AddressType,
      AddressTypeName: this.searchCriteria.AddressTypeName,
      AddressTypeId: this.searchCriteria.AddressTypeId,
      IsPortfolio: this.searchCriteria.IsPortfolio,
      LatFrom: '15.982084553605485',
      LatTo: '51.41267274848109',
      LongFrom: '-160.39062',
      LongTo: '-29.609375',
      PropertySequenceId: this.searchCriteria.PropertySequenceId,
      DOMStartDate: this.searchCriteria.DOMStartDate == null ? null : this.Validation.utcify(this.searchCriteria.DOMStartDate),
      DOMEndDate: this.searchCriteria.DOMEndDate == null ? null : this.Validation.utcify(this.searchCriteria.DOMEndDate),
      TenantAddress: this.searchCriteria.TenantAddress,
      CityId: this.searchCriteria.CityId
    };

    //super.propertySearchCriteria(searchCriteria);
    this._propertyListingService.criteria = searchCriteria;
    this.searchCriteria = searchCriteria;
    //this.dtElement.dtInstance.then(x => x.draw());
  }


  LoadData(id: string) {

    this.user = this.authService.user;
    this.searchCriteriaInitialization();

    this.pageLoad = true;
    this.mapEx = new google.maps.Map(this.mapContainer.nativeElement, {
      minZoom: 3,
      zoom: 5,
      gestureHandling: 'cooperative', //(if needed to enable ctrl+zoom)
      //scrollwheel: false,
    });

    this.setDefaultMapPostions();

    this.mapEx.addListener('dragend', () => {
      this.boundsChanged.emit(this.mapEx.getBounds());
      this.filterFromClusters();
      //this.onTenantSelectionChange();
    });

    this.mapEx.addListener('zoom_changed', () => {
      if (!this.mapFlag && this.count <= 2) {
        this.boundsChanged.emit(this.mapEx.getBounds());
      }
      this.mapFlag = false;
      if (!this.pageLoad) { this.filterFromClusters(); }
      //this.onTenantSelectionChange();
    });
    this.dtOptions1 = {
      info: false,
      lengthChange: false,
      paging: false,
    };

    let dataColums = [
      { data: 'PropertyName' },
      { data: 'PropertyName' },
      { data: 'PropertySequenceId' },
      { data: 'PropertyName' },
      { data: 'State' },
      { data: 'City' },
      { data: 'PropertyStatus' },
      { data: 'Price' },
      { data: 'RentNOI' },
      { data: 'CreditRating' },
      { data: 'CapRate' },
      { data: 'RemainingTerm' },
      { data: 'LeaseStructure' },
      { data: 'BuildingSize' },
      { data: 'Rank' }
    ];
    const that = this;
    if (!this.savedAnalytics) {
      id = null;
    }
    if (id == null) {
      this.loadMap();
    }
    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
      },
      "pageLength": 50,
      "order": [[3, "asc"]],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: async (dataTablesParameters: any, callback: Function) => {

        this.setMapSelectedBounds();

        this._subscriptions.push(await this._propertyListingService.getSavedAnalyticsSearch(id).subscribe(result => {
          this.searchCriteria.IsLatLongEnabled = true;
          this.searchCriteria.PropertyStatus = [351];
          if (id != null && this.savedAnalytics) {
            this.searchCriteria = result.SaveSearchInputModel.PropertySearchCriteria;
            this.savedAnalytics = true;
            this.propertySearchCriteria2(this.searchCriteria);
            this.showSearch = true;
          }
          else {
            this.showSearch = true;
          }

          dataTablesParameters.Extra_param = this.searchCriteria;
          dataTablesParameters.Extra_param.IsComp = false;
          dataTablesParameters.Extra_param.IsArchive = false;
          dataTablesParameters.Extra_param.PropertyFor = 0;
          dataTablesParameters.Extra_param.IsLatLongEnabled = true;
          const httpHeader = this.Validation.GetAuthHeader();
          that.http.post<DataTablesResponse>(this.BASE_URL + '/property/analyticsPropertiesList/' + this.user.Id, dataTablesParameters, httpHeader).subscribe(resp => {
            that.properties = [];
            that.properties = resp.data ? resp.data : [];

            this.properties.forEach(item => {
              if (this.selectedRows.findIndex(x => x.Id == item.Id) > -1) {
                item.IsSelected = true;
              }
              item.Remaining_Term = this.Validation.remainingTermForCardandTables(item.LeaseExpiration, item.LeaseCommencementDate);
            });

            this.autoSelectAll();
            if (id != null) {

              this.Loader.display(true);
              setTimeout(() => {
                this.selectSavedProperties(result.PropertyIds);
                this.chartInput.TenantId = result.TenantId;
                this.tenantSelect(false, true);
                setTimeout(() => {
                  this.chartInput.PropertyType = result.PropertyTypeId != null ? result.PropertyTypeId : 0;
                  this.chartInput.Subcategory = result.SubCategoryId != null ? result.SubCategoryId : 0;
                  this.bindSubCategory(this.savedAnalytics);
                  this.chartInput.StartDate = this.Validation.convertUTCDateToLocalDate(result.StartDate);
                  this.chartInput.EndDate = this.Validation.convertUTCDateToLocalDate(result.EndDate);
                  this.bindAllGraphOnViewClick();
                  this.isSCActiveListing = result.IsActiveListing;
                  $('#chk3').prop('checked', !this.isSCActiveListing);
                  setTimeout(() => {
                    this.bindSubcategoryContribution();
                    if (result.IsMapExpanded) {
                      this.expandMap();
                    }
                  }, 1000);
                }, 1000);
                this.Loader.display(false);
              }, 2000);
            }
            else if (this.clearSaved) {
              this.showAnalyticsGraphs = false;
              this.resetSelectedRows();
              if (this.expandedMap) {
                this.expandMap();
              }
            }

            this.pageLoad = false;
            if (resp.data.length === 0) {
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
            else {
              $(".dataTables_paginate.paging_full_numbers").show();
            }
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
            }
            else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
            }
            $(".paginate_button.first,.paginate_button.last").hide();
          });
        }));
      },
      columnDefs: [
        { orderable: false, targets: 0 },
        { orderable: false, targets: 1 }
      ],
      columns: dataColums
    };
    if (id != null) {
      this.loadMap();
    }
  }

  tenantList: any = [];
  private setDefaultMapPostions() {
    const southWest = new google.maps.LatLng(this.latFromValue, this.longFromValue);
    const northEast = new google.maps.LatLng(this.latToValue, this.longToValue);
    const bounds = new google.maps.LatLngBounds(southWest, northEast);
    this.mapEx.fitBounds(bounds);
  }

  showGraphsOnAnalyzeClick() {
    if (this.selectedRows.length > 0) {
      this.showAnalyzeBtn = false;
      this.showAnalyticsGraphs = true;
      let selectedPropertyId = [];
      this.selectedRows.forEach(item => {
        selectedPropertyId.push(item.Id);
      });
      this.tenantList = [];
      this.Analytics.GetTenantsOfProperties(selectedPropertyId).subscribe(response => {
        this.tenantList = response;
        if (this.tenantList.length > 0) {
          this.chartInput.TenantId = this.tenantList[0].Id;
          this.setDynamicLabels();
          this.setCurrentDates();
          this.bindTypeAndplotChart(true);
          this.Validation.scrollToElement("divAnalytics", 90);
        }
      });
    }
    else {
      if (!this.savedAnalytics) {
        this.Toast.addToast({ title: 'Error Occurred', msg: 'Please select at least 1 property', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
      else {
        this.Toast.addToast({ title: 'Error Occurred', msg: 'There are no available properties in the saved analytics', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        this.showAnalyticsGraphs = false;
        this.resetSelectedRows();
        if (this.expandedMap) {
          this.expandMap();
        }
      }
    }
  }

  async bindTypeAndplotChart(plot = false, saved = false) {
    this.setSelectedProperties();
    this.chartInput.Type = 1;
    await this.Analytics.GetTypeAndSubcategoryOfProperty(this.chartInput).subscribe(x => {
      this.propertyData = x;
      this.subCategoriesList = [];
      this.propertyTypesList = [];

      this.propertyData.forEach(item => {
        this.propertyTypesList.push(item);
      });
      this.chartInput.PropertyType = this.propertyTypesList[0].Id;
      this.bindSubCategory(this.savedAnalytics);
      if (plot) {
        this.bindOtherChart();
      }
    });
  }

  async bindSubCategory(saved = false) {
    this.setSelectedProperties();
    this.chartInput.Type = 2;
    this.showAnalyticsGraphs = this.savedAnalytics;
    await this.Analytics.GetTypeAndSubcategoryOfProperty(this.chartInput).subscribe(x => {
      this.propertyData = x;
      this.subCategoriesList = [];
      this.propertyData.forEach(item => {
        this.subCategoriesList.push(item);
      });
      this.chartInput.Subcategory = this.subCategoriesList.length > 0 ? this.subCategoriesList[0]["Id"] : -1;
    });
  }


  hideAnalyticsGraphs() {
    this.showAnalyticsGraphs = false;
  }

  tenantSelect(plot = false, saved = false, isManual = false) {

    if (!this.savedAnalytics || isManual) {
      this.setTenantDates();
      this.setCurrentDates(saved);
      this.savedAnalytics = false;
    }
    this.bindTypeAndplotChart(plot, saved);
    this.showAnalyticsGraphs = saved;
  }

  bindAllGraphOnViewClick() {

    if ((this.Validation.IsinValid(this.chartInput.StartDate) || this.Validation.IsinValid(this.chartInput.EndDate)) && this.selectedRows.length > 0) {
      this.Toast.addToast({ title: 'Error Occurred', msg: 'Start Date and End Date are required ', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      return;
    }

    if (this.selectedRows.length == 0) {
      if (!this.savedAnalytics) {
        this.Toast.addToast({ title: 'Error Occurred', msg: 'Please select at least 1 property', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        return;
      }
      else {
        this.Toast.addToast({ title: 'Error Occurred', msg: 'There are no available properties in the saved analytics', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        this.showAnalyticsGraphs = false;
        this.resetSelectedRows();
        if (this.expandedMap) {
          this.expandMap();
        }
      }
    }

    if ((this.chartInput.StartDate.getUTCFullYear() < 1753 || this.chartInput.EndDate.getUTCFullYear() < 1753) && this.selectedRows.length > 0) {
      this.Toast.addToast({ title: 'Error Occurred', msg: 'Start Date and End Date must be between 1/1/1753 and 12/31/9999 ', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      return;
    }

    if (this.selectedRows.length > 0) {
      this.bindGraphs();
    }
    else {
      if (!this.savedAnalytics) {
        this.Toast.addToast({ title: 'Error Occurred', msg: 'Please select at least 1 property', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
      else {
        this.Toast.addToast({ title: 'Error Occurred', msg: 'There are no available properties in the saved analytics', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        this.showAnalyticsGraphs = false;
        this.resetSelectedRows();
        if (this.expandedMap) {
          this.expandMap();
        }
      }
    }
  }

  @Input() imagesLocation = 'assets/img/m';
  isReset = false;
  private _selectedProperty: IPropertyCard;
  private count = 0;

  private setTenantDates() {
    this.Analytics.GetPropertyDates(this.chartInput.TenantId).subscribe(x => {
      try {
        this.propertyDates = x;
        if (!this.Validation.IsinValid(this.propertyDates.DateOnMarket)) {
          this.minDate = this.Validation.convertUTCDateToLocalDate(this.propertyDates.DateOnMarket);
        }
        else if (!this.Validation.IsinValid(this.propertyDates.CreatedDate)) {
          this.minDate = this.Validation.convertUTCDateToLocalDate(this.propertyDates.CreatedDate);
        }
      }
      catch { }
    });
  }

  public get selectedProperty(): IPropertyCard {

    return this._selectedProperty;
  }

  public set selectedProperty(v: IPropertyCard) {

    this._selectedProperty = v;
  }

  private _propertiesCache: IPropertyCard[] = [];
  public get propertiesCache(): IPropertyCard[] {
    return this._propertiesCache;
  }
  public set propertiesCache(v: IPropertyCard[]) {
    this._propertiesCache = v;
  }

  resetSelectedRows() {
    this.selectedRows = [];
    if (this.properties) {
      this.properties.forEach(item => {
        item.IsSelected = false;
      });
      this.propertiesCache.forEach(item => {
        item.IsSelected = false;
      });
    }
    this.autoSelectAll();
    this.showAnalyticsGraphs = false;
    this.tenantList = [];
    this.propertyTypesList = [];
    this.subCategoriesList = [];
    this.refreshMap();
  }
  refreshMap() {
    const that = this;
    if (!that.markerCluster) {
      that.markerCluster = new MarkerClusterer(that.mapEx, that.markers,
        { imagePath: that.imagesLocation });
    }
    that.markerCluster.clearMarkers();
    if (that.selectedMarker != null) {
      that.selectedMarker.setMap(null);
    }

    const markers = that.propertiesCache.map(function (location, i) {
      const marker = new google.maps.Marker({
        position: { lat: location.Lat, lng: location.Lng },
        icon: that.checkMarkerIsSelected(location.Id),
        title: location.Id.toString(),
      });

      marker.addListener('mouseover', (e: google.maps.MapMouseEvent) => {

        if (that.activeWindow) { that.activeWindow.close(); }

        that.selectedProperty = that.propertiesCache.find(x => {
          return x.Lat === parseFloat(e.latLng.lat().toString()) && x.Lng.toFixed(7) === e.latLng.lng().toFixed(7);
        });

        that.selectedMarker = that.markers.find(x => x.getPosition().lat() === e.latLng.lat() && x.getPosition().lng() === e.latLng.lng());

        if (that.selectedMarker) {
          if (!that.selectedMarker.getMap()) {
            that.selectedMarker.setMap(that.mapEx);
          }
        }

        if (that.selectedProperty) {
          if (that.selectedProperty.FilePath === undefined || that.selectedProperty.FilePath === null) {
            that.selectedProperty.FilePath = '/../../../assets/img/default-property_1.png'
          }
          var content = ' <div class="property-map ">' +
            '<div class="imgblock" style= "background-image:url(' + that.Validation.IsNullOrEmptyThen(that.selectedProperty.FilePath, that.defaultImagePath) + ')" > </div>' +
            '<h2> <strong>' + that.selectedProperty.PropertyName + '</strong><span>' + that.selectedProperty.City + ', ' + that.selectedProperty.State + '</span > </h2>' +
            '<h3>' + '$ ' + that.Validation.decimalCommaFormat(that.selectedProperty.Price) + ' </h3>' +
            '</div>'
          that.infoWindow = new google.maps.InfoWindow({
            content: content,
            maxWidth: 200,

          });

          that.infoWindow.open(that.mapEx, that.selectedMarker);
          that.activeWindow = that.infoWindow;
          that.infoWindow.addListener('closeclick', (e) => {

          });
        }

        if (that.selectedRows.findIndex(x => x.Id == that.selectedProperty.Id) > -1) {
          that.selectedMarker.setIcon(that.selectedMarkerIcon);
        }
        else {
          that.selectedMarker.setIcon(that.markerIcon);
        }
      });

      marker.addListener('mouseout', function () {
        that.infoWindow.close();
      });

      marker.addListener('click', (e: google.maps.MapMouseEvent) => {

        that.activeWindow.close();

        that.selectedProperty = that.propertiesCache.find(x => {
          return x.Lat === parseFloat(e.latLng.lat().toString()) && x.Lng.toFixed(7) === e.latLng.lng().toFixed(7);
        });

        if (!that.propertiesCache.some((item) => item.Id == that.selectedProperty.Id)) {
          that.propertiesCache.push(that.selectedProperty);
        }
        that.selectedMarker = that.markers.find(x => x.getPosition().lat() === e.latLng.lat() && x.getPosition().lng() === e.latLng.lng());

        if (that.selectedMarker) {
          if (!that.selectedMarker.getMap()) {
            that.selectedMarker.setMap(that.mapEx);
          }
        }

        if (that.selectedRows.findIndex(x => x.Id == that.selectedProperty.Id) < 0) {
          that.onCheckboxChange(true, that.selectedProperty.Id, true);
          let currentPropertyOnDataTable = that.properties.find(x => x.Id == that.selectedProperty.Id);
          if (currentPropertyOnDataTable) {
            currentPropertyOnDataTable.IsSelected = true;
          }
          that.selectedMarker.setIcon(that.selectedMarkerIcon);
        }
        else {
          that.onCheckboxChange(false, that.selectedProperty.Id, true);
          let currentPropertyOnDataTable = that.properties.find(x => x.Id == that.selectedProperty.Id);
          if (currentPropertyOnDataTable) {
            currentPropertyOnDataTable.IsSelected = false;
          }
          that.selectedMarker.setIcon(that.markerIcon);
        }
        that.autoSelectAll();
        that.onTenantSelectionChange();
      });

      if (that.isReset == true) {
        if (that.mapEx != null) {
          const southWest = new google.maps.LatLng(that.latFromValue, that.longFromValue);
          const northEast = new google.maps.LatLng(that.latToValue, that.longToValue);
          const bounds = new google.maps.LatLngBounds(southWest, northEast);
          that.mapEx.fitBounds(bounds);
          that.count += 1
        }
      }
      that.isReset = false;
      that.markers.push(marker);
      return marker;
    });
    that.markerCluster.addMarkers(markers);
    that.markerCluster.draw();
  }

  checkMarkerIsSelected(propertyId) {
    if (this.selectedRows.findIndex(x => x.Id == propertyId) > -1) {
      return this.selectedMarkerIcon;
    }
    else {
      return this.markerIcon;
    }
  }

  defaultImagePath = '/../../../assets/img/default-property_1.png';
  onSelectAll(event) {
    this.savedAnalytics = false;
    this.hideselectionLinks = false;
    if (event.target.checked) {
      this.selectOrUnSelectAll(true);
    }
    else {
      this.showAnalyticsGraphs = false;
      this.selectOrUnSelectAll(false);
    }
  }
  selectedRows: IPropertyCard[] = [];
  selectAll = false;
  onCheckboxChange(checked, Id, IsFromMap = false) {
    this.Loader.display(true);
    this.savedAnalytics = false;
    this.hideselectionLinks = true;
    let prop;
    if (IsFromMap) {
      let propertyid = [];
      propertyid.push(Id);
      this._propertyListingService.GetPropertyInfoForAnalytics(propertyid, false).subscribe((response: IPropertyCard[]) => {
        prop = response ? response[0] : null;
        this.checkboxEvent(Id, checked, prop);
      });
    }
    else {
      prop = this.properties.find(x => x.Id == Id);
      this.checkboxEvent(Id, checked, prop);
    }
  }

  private checkboxEvent(Id: any, checked: any, prop: any) {
    //let selectedMarker = this.markers.find(x => x.getPosition().lat().toString() === prop.Latitude && x.getPosition().lng().toString() === prop.Longitude);
    let selectedMarker = this.markers.find(x => x.getTitle().toString() == Id.toString());
    prop.Remaining_Term = this.Validation.remainingTermForCardandTables(prop.LeaseExpiration, prop.LeaseCommencementDate);
    this.hideAnalyticsGraphs();
    if (checked) {
      prop.IsSelected = true;
      this.selectedRows.push(prop);

      if (selectedMarker) {
        this.refreshMap();
        this.bindTenantTypeSubcategory();
        this.bindAnalyticsDetails();
      }
    }
    else {
      prop.IsSelected = false;
      this.selectedRows.splice(this.selectedRows.findIndex(x => x.Id == Id), 1);
      if (selectedMarker) {
        this.refreshMap();
        this.bindTenantTypeSubcategory();
        this.bindAnalyticsDetails();
      }
    }
    this.autoSelectAll();
    this.onTenantSelectionChange();
    this.Loader.display(false);
  }

  async bindTenantTypeSubcategory(onSelectAllClick = false) {
    let selectedPropertyId = [];
    this.selectedRows.forEach(item => {
      selectedPropertyId.push(item.Id);
    });
    this.tenantList = [];
    await this.Analytics.GetTenantsOfProperties(selectedPropertyId).subscribe(response => {
      this.tenantList = response;
      if (this.tenantList.length == 1 || (onSelectAllClick && this.tenantList.length > 0)) {
        if (!this.savedAnalytics) {
          this.chartInput.TenantId = this.tenantList[0].Id;
        }
        this.setDynamicLabels();
        this.setCurrentDates();
        this.chartInput.PropertyType = 0;
        this.bindTypeAndplotChart(false);
      }
      else if (this.tenantList.length == 0) {
        this.tenantList = [];
        this.propertyTypesList = [];
        this.subCategoriesList = [];
      }
    });
  }

  private onTenantSelectionChange() {
    //this.showAnalyzeBtn = true;
    //this.showAnalyticsGraphs = false;
  }

  onPropertySelect(selectedPropertyId) {
    this.Analytics.GetTenantsOfProperties(selectedPropertyId).subscribe(response => {
      this.tenantList.push(response);
      //if (this.tenantList.length > 0) {
      //    this.chartInput.TenantId = this.tenantList[0].Id;
      //    this.setDynamicLabels();
      //    this.chartInput.EndDate = new Date();
      //    this.chartInput.StartDate = new Date();
      //    this.bindTypeAndplotChart(true);
      //    this.Validation.scrollToElement("divAnalytics", 90);
      //}
    });
  }

  expandChart(div, index) {
    if ($('#' + div).hasClass('expand-div')) {
      $('#' + div).removeClass('expand-div');
      $('body').removeClass('modal-open');

      if (index == 5) {
        this.bindLineChart(false);
      }
    }
    else {
      $('#' + div).addClass('expand-div');
      $('body').addClass('modal-open');

      if (index == 5) {
        this.bindLineChart(true);
      }
    }
    if (index == 1) {
      this.bindSubcategoryContribution();
    }
    else if (index == 2 || index == 3 || index == 4) {
      this.bindBarActiveListingAskingPrice(index);
    }
  }

  isChartExpended(div) {
    if ($('#' + div).hasClass('expand-div')) {
      return 'Collapse The Chart';
    }
    else {
      return 'Expand The Chart';
    }
  }
  expandMap() {
    this.expandedMap = !this.expandedMap;
    $('.map-listing-wrap').toggleClass('expand-div');
  }
  hideselectionLinks = false;
  selectOrUnSelectAll(trueOrfalse, selectAllRows = false) {
    if (!selectAllRows) {
      this.properties.forEach(item => {
        item.IsSelected = trueOrfalse;

        let currentPropertyOnDataTable = this.propertiesCache.find(x => x.Id == item.Id);
        if (currentPropertyOnDataTable) {
          currentPropertyOnDataTable.IsSelected = trueOrfalse;
        }

        if (trueOrfalse) {
          // if true then push all selected items into selectedRows collection
          if (this.selectedRows.findIndex(x => x.Id == item.Id) < 0) {
            this.selectedRows.push(item);
          }
        }
        else {
          // if false then current item from the selected row collection
          this.selectedRows.splice(this.selectedRows.findIndex(x => x.Id == item.Id), 1);
        }
      });
    }
    else {
      this.Loader.display(true);
      setTimeout(() => {
        this.selectedDatapoint = false;
        this.Loader.display(false);
      }, 2000);

      this.hideselectionLinks = true;
      this.propertiesCache.forEach(item => {
        item.IsSelected = trueOrfalse;

        let currentPropertyOnDataTable = this.properties.find(x => x.Id == item.Id);
        if (currentPropertyOnDataTable) {
          currentPropertyOnDataTable.IsSelected = trueOrfalse;
        }

        if (trueOrfalse) {
          // if true then push all selected items into selectedRows collection
          if (this.selectedRows.findIndex(x => x.Id == item.Id) < 0) {
            this.selectedRows.push(item);
          }
        }
        else {
          // if false then current item from the selected row collection
          this.selectedRows.splice(this.selectedRows.findIndex(x => x.Id == item.Id), 1);
        }
      });
    }

    if (this.propertiesCache.length == this.selectedRows.length) {
      this.hideselectionLinks = true;
    }

    this.bindAnalyticsDetails();
    this.bindTenantTypeSubcategory(true);
    this.refreshMap();
    this.hideAnalyticsGraphs();
    if (!trueOrfalse) {
      this.selectAll = false;
    }
  }
  openAnalyzeModal(template: TemplateRef<any>, classes: any) {
    this.saveAnalyticsInput.Name = null;
    this.modalRef = this.modalService.show(template, { class: classes });
  }
  selectSavedProperties(propertIds: number[]) {
    if (propertIds.length <= 50) {
      this.properties.forEach(item => {

        if (propertIds.includes(item.Id)) {
          item.IsSelected = true;

          let currentPropertyOnDataTable = this.propertiesCache.find(x => x.Id == item.Id);
          if (currentPropertyOnDataTable) {
            currentPropertyOnDataTable.IsSelected = true;
          }

          if (true) {
            // if true then push all selected items into selectedRows collection
            if (this.selectedRows.findIndex(x => x.Id == item.Id) < 0) {
              this.selectedRows.push(item);
            }
          }
        }
      });
    }
    else {
      this.propertiesCache.forEach(item => {
        if (propertIds.includes(item.Id)) {
          item.IsSelected = true;

          let currentPropertyOnDataTable = this.properties.find(x => x.Id == item.Id);
          if (currentPropertyOnDataTable) {
            currentPropertyOnDataTable.IsSelected = true;
          }

          if (true) {
            // if true then push all selected items into selectedRows collection
            if (this.selectedRows.findIndex(x => x.Id == item.Id) < 0) {
              this.selectedRows.push(item);
            }
          }
        }
      });
      if (this.propertiesCache.length == this.selectedRows.length) {
        this.selectAll = true;
      }
    }


    if (this.propertiesCache.length == this.selectedRows.length) {
      this.hideselectionLinks = true;
    }

    this.bindAnalyticsDetails();
    this.bindTenantTypeSubcategory(true);
    this.refreshMap();
  }

  autoSelectAll() {
    if (this.properties.filter(x => x.IsSelected == true).length == this.properties.length && this.properties.length > 0) {
      this.selectAll = true;
    }
    else {
      this.selectAll = false;
    }
  }

  dtOptionsProperties = {};
  properties: IPropertyCard[];
  protected readonly BASE_URL: string = environment.base_url;
  user: any;
  private searchCriteriaInitialization() {

    this._propertyListingService.criteria.PropertyFor = 0;
    this.searchCriteria = this._propertyListingService.criteria;
    this.searchCriteria.IsExport = false;
    this.searchCriteria.IsLatLongEnabled = true;
    this.mapInitialization();
  }

  private mapInitialization() {
    this.searchCriteria.LatFrom = '15.982084553605485';
    this.searchCriteria.LatTo = '51.41267274848109';
    this.searchCriteria.LongFrom = '-160.39062';
    this.searchCriteria.LongTo = '-29.609375';
  }

  mapFlag: boolean;
  private loadMap() {
    this.filterFromClusters();
  }
  initailDelay = 1000;
  loadMapAndTableData(searchCriteria: IPropertySearchCriteria) {
    //searchCriteria = this.searchCriteria;
    this.Loader.display(true);
    this.searchCriteria.IsLatLongEnabled = true;
    this.searchCriteria.PropertyStatus = [351];
    setTimeout(async () => {
      await this._propertyListingService.GetPropertiesForAnalytics(this.searchCriteria).subscribe((response: IPropertyCard[]) => {
        this.propertiesCache = response ? response : [];
        if (this.activeWindow) {
          this.activeWindow.close();
        }
        this.refreshMap();
        this.initailDelay = 0;
        if (!this.pageLoad) {
          this.Loader.display(false);
        }
      });
    }, this.initailDelay);

    if (this.pageLoad) {
      this.Loader.display(false);
    }
    if (!this.pageLoad) {
      this.reloadDataTable();
    }
  }

  private reloadDataTable() {
    //this.dtElement.dtInstance.then((dtInstance: ) => {
    //    dtInstance.destroy();
    //    this.dtTrigger.next(true);
    //});
    this.dtElement.dtInstance.then(x => x.draw());
  }

  filterFromClusters(onDone?: Function) {
    this.setMapSelectedBounds();
    let searchCriteria = this.searchCriteria;
    searchCriteria.IsMapView = true;
    searchCriteria.IsTileList = true;
    this.loadMapAndTableData(searchCriteria);
  }

  private setMapSelectedBounds() {
    this.boundsChanged.emit(this.mapEx.getBounds());
    const bounds = this.mapEx.getBounds();
    if (bounds) {
      this.searchCriteria.LatFrom = bounds.getSouthWest().toJSON().lat.toString();
      this.searchCriteria.LatTo = bounds.getNorthEast().toJSON().lat.toString();
      this.searchCriteria.LongFrom = bounds.getSouthWest().toJSON().lng.toString();
      this.searchCriteria.LongTo = bounds.getNorthEast().toJSON().lng.toString();
    }
    else {
      this.mapInitialization();
    }
  }

  //bindType(plot = false) {
  //    this.common.getTypeList().subscribe(response => {
  //        let data = response;
  //        this.propertyTypesList = [];
  //        data.forEach(item => {
  //            if (this.propertyTypes.findIndex(x => x.Id == item.Id) > -1) {
  //                this.propertyTypesList.push(item);
  //            }
  //        });
  //        if (plot) {
  //            this.PropertyTypeText = this.propertyTypesList.find(x => x.Id == this.chartInput.PropertyType)["Name"];
  //        }
  //        this.bindSubcategory(plot);
  //    });
  //}

  //bindSubcategory(plot = false) {
  //    let propertyTypeList = [];
  //    propertyTypeList.push(this.chartInput.PropertyType);
  //    this.common.getSubcategoryList(propertyTypeList).subscribe(res => {
  //        let data = res;
  //        this.subCategoriesList = [];
  //        data.forEach(item => {
  //            if (this.propertyTypeSubcategorys.findIndex(x => x.Id == item["Id"]) > -1) {
  //                this.subCategoriesList.push(item);
  //            }
  //        });
  //        if (plot) {
  //            let find = this.subCategoriesList.find(x => x.Id == this.chartInput.Subcategory);
  //            if (find) {
  //                this.SubcategoryText = find["Name"];
  //            }
  //            else {
  //                this.SubcategoryText = '';
  //            }
  //        }
  //        if (plot) {
  //            this.bindBarPropertyTypeToSubcategory();
  //        }
  //    });
  //}

  bindAnalyticsDetails() {
    this.setFilters();
    this.setSelectedProperties();
    this.Analytics.GetAnalyticsDetails(this.chartInput).subscribe(response => {
      this.analyticsDetails = response;
    });
  }

  bindGraphs() {
    this.showAnalyticsGraphs = true;
    this.setFilters();
    this.setDynamicLabels();
    this.bindOtherChart();
    this.bindBarPropertyTypeToSubcategory();
  }

  setCurrentDates(saved = false) {
    if (!saved) {
      this.chartInput.EndDate = new Date();
      this.chartInput.StartDate = new Date();
      this.chartInput.StartDate = new Date(this.chartInput.StartDate.setMonth(this.chartInput.StartDate.getMonth() - 5));
    }
  }

  bindOtherChart(mode?: number) {
    let items = $('#hdn_selectedStates').val().toString().split(",");
    this.selectedStatesList = [];
    items.forEach(item => {
      if (item.length > 0) {
        this.selectedStatesList.push(item);
      }
    });

    this.setSelectedProperties();
    //this.chartInput.StartDate = this.Validation.utcify(this.chartInput.StartDate);
    //this.chartInput.EndDate = this.Validation.utcify(this.chartInput.EndDate);

    this.bindBarActiveListingAskingPrice();
    this.bindLineChart();
    this.bindSubcategoryContribution();
    //this.bindAnalyticsDetails();
    this.bindTenantBreakdown();
  }

  setSelectedProperties() {
    let selectedPropertyIds = [];
    this.selectedRows.forEach(item => {
      selectedPropertyIds.push(item.Id);
    });

    this.chartInput.Id = selectedPropertyIds;
  }

  getselectedRowsOfTenant() {
    return this.selectedRows.filter(x => x.TenantId == this.chartInput.TenantId);
  }

  bindLineChart(isExpand = false) {
    this.Analytics.GetLineChartData(this.chartInput).subscribe(response => {
      let data = response;

      let Xaxis = [];
      let ActiveListing = [];
      let AvgCapRate = [];
      let AvgPrice = [];
      let RemainingTerm = [];
      data.forEach(item => {
        Xaxis.push(item["XAxis"]);
        ActiveListing.push(item["ActiveListing"]);
        AvgCapRate.push(item["AvgCapRate"]);
        AvgPrice.push(item["AvgPrice"]);
        RemainingTerm.push(item["RemainingTerm"]);
      });

      let HighchartsArea = Highcharts;

      /**
       * In order to synchronize tooltips and crosshairs, override the
       * built-in events with handlers defined on the parent element.
       * 
       */
      ['mousemove', 'touchmove', 'touchstart'].forEach(function (eventType) {
        document.getElementById('container_areachart').addEventListener(
          eventType,
          function (e) {
            var chart,
              point,
              i,
              event;

            for (i = 0; i < HighchartsArea.charts.length; i = i + 1) {
              chart = HighchartsArea.charts[i];

              if (chart && chart.title.textStr.length > 0) {
                // Find coordinates within the chart
                event = chart.pointer.normalize(e);
                // Get the hovered point
                point = chart.series[0].searchPoint(event, true);

                if (point) {
                  point.highlight(e);
                }
              }
            }
          }
        );
      });

      /**
      * Override the reset function, we don't need to hide the tooltips and
      * crosshairs.
      */
      HighchartsArea["Pointer"].prototype.reset = function () {
        return undefined;
      };

      /**
       * Highlight a point by showing tooltip, setting hover state and draw crosshair
       */
      HighchartsArea["Point"].prototype["highlight"] = function (event) {
        event = this.series.chart.pointer.normalize(event);
        this.onMouseOver(); // Show the hover marker
        try {
          this.series.chart.tooltip.refresh(this); // Show the tooltip
        }
        catch { }
        this.series.chart.xAxis[0].drawCrosshair(event, this); // Show the crosshair
      };

      function syncExtremes(e) {
        var thisChart = this.chart;
      }


      // Get the data. The contents of the data file can be viewed at
      let activity = {
        "xData": Xaxis,
        "datasets": [{
          "name": "# On Market",
          "data": ActiveListing,
          "unit": " ",
          "type": "area",
          "valueDecimals": 0,
        }, {
          "name": "Average Remaining Term",
          "data": RemainingTerm,
          "unit": "yrs",
          "type": "area",
          "valueDecimals": 1,
        }, {
          "name": "Average Price",
          "data": AvgPrice,
          "unit": "$",
          "type": "area",
          "valueDecimals": 0,
        }, {
          "name": "Average Cap Rate",
          "data": AvgCapRate,
          "unit": "%",
          "type": "area",
          "valueDecimals": 1,
        }]
      }
      let areaChart: any;
      $("#container_areachart").empty();
      activity.datasets.forEach(function (dataset, i) {

        // Add X values
        dataset.data = HighchartsArea.map(dataset.data, function (val, j) {
          return [activity.xData[j], val];
        });

        var chartDiv = document.createElement('div');
        chartDiv.className = 'chart';
        document.getElementById('container_areachart').appendChild(chartDiv);
        areaChart = {
          chart: {
            marginLeft: 50, // Keep all charts left aligned
            spacingTop: 20,
            spacingBottom: 20,
            height: 350,
          },
          title: {
            text: dataset.name,
            align: 'left',
            margin: 0,
            x: 30
          },
          credits: {
            enabled: false
          },
          legend: {
            enabled: false
          },
          xAxis: {
            crosshair: true,
            categories: Xaxis,
            events: {
              setExtremes: syncExtremes
            },
            //labels: {
            //    format: '{value} km'
            //}
          },
          yAxis: {
            title: {
              text: null
            }
          },
          tooltip: {
            positioner: function () {
              return {
                // right aligned
                x: this.chart.chartWidth - this.label.width,
                y: 10 // align to title
              };
            },
            borderWidth: 0,
            backgroundColor: 'none',
            //pointFormat: '{point.y}',
            pointFormatter: function () {
              var point = this;
              let value = point.y;
              if (this.series.name == "Average Price") {
                value = Math.abs(Number(value)) >= 1.0e+12
                  ? Math.abs(Number(value)) / 1.0e+12 + "T"
                  : Math.abs(Number(value)) >= 1.0e+9
                    ? Math.abs(Number(value)) / 1.0e+9 + "B"
                    : Math.abs(Number(value)) >= 1.0e+6
                      ? Math.abs(Number(value)) / 1.0e+6 + "M"
                      : Math.abs(Number(value)) >= 1.0e+3
                        ? Math.abs(Number(value)) / 1.0e+3 + "K"
                        : Math.abs(Number(value));

                let lastChar = value.toString().charAt(value.length - 1);
                value += '';
                var x = value.split('.');
                var x1 = x[0];
                var x2 = x.length > 1 ? '.' + x[1] : '';
                value = x1 + x2.substr(0, 2) + ((isNaN(lastChar) && value.indexOf('.') > -1) ? lastChar : '');
                return '$' + value;
              }
              else if (this.series.name == "Average Remaining Term") {
                return value + ' yrs';
              }
              else if (this.series.name == "Average Cap Rate") {
                return value + ' %';
              }
              else {
                return value;
              }
            },
            headerFormat: '',
            shadow: false,
            style: {
              fontSize: '18px'
            },
            valueDecimals: dataset.valueDecimals
          },
          series: [{
            data: dataset.data,
            name: dataset.name,
            type: dataset.type,
            color: '#198FDE',
            //color: HighchartsArea.getOptions().colors[i],
            fillColor: '#8cc7ee',
            //fillOpacity: 0.3,
            tooltip: {
              valueSuffix: ' ' + dataset.unit
            }
          }]
        }
        HighchartsArea.chart(chartDiv, areaChart);
      });
    });
  }

  changeColor(i) {
    return 'red';
  }

  private setDynamicLabels() {
    if (this.tenantList.length > 0) {
      this.tenantName = this.tenantList.find(x => x.Id == this.chartInput.TenantId)["Name"];
    }

    if (this.propertyTypesList) {
      let find = this.propertyTypesList.find(x => x.Id == this.chartInput.PropertyType);
      if (find) {
        this.PropertyTypeText = find["Name"];
      }
      else {
        this.PropertyTypeText = '';
      }
    }

    if (this.subCategoriesList) {
      let find = this.subCategoriesList.find(x => x.Id == this.chartInput.Subcategory);
      if (find) {
        this.SubcategoryText = find["Name"];
      }
      else {
        this.SubcategoryText = '';
      }
    }
  }

  bindBarActiveListingAskingPrice(reloadType = 0) {
    this.setFilters();
    this.chartInput.Mode = this.isActiveListing ? 1 : 2;

    this.Analytics.GetActiveListingAskingPrice(this.chartInput).subscribe(response => {
      let data = response;
      let barChartData = [];
      let barChartAskingPrice = [];
      let capRate = [];
      let remainingTerm = [];
      let Xaxis = [];
      data.forEach(item => {
        barChartData.push(item["ActiveListing"]);
        barChartAskingPrice.push(item["AvgPrice"]);
        capRate.push(item["AvgCapRate"]);
        remainingTerm.push(item["RemainingTerm"]);
        Xaxis.push(item["XAxis"]);
      });

      if (reloadType == 0 || reloadType == 2) {
        this.barActiveListingAskingPrice = {
          chart: {
            type: 'column',
            height: 400
          },
          title: {
            text: ''
          },
          xAxis: {
            categories: Xaxis,
            crosshair: true
          },
          yAxis: [{
            min: 0,
            title: {
              text: '# On Market'
            },
            allowDecimals: false
          }, {
            title: {
              text: 'Avg Cap Rate'
            },
            opposite: true,
            labels: {
              format: '{value}%'
            },
            allowDecimals: true,
          }],
          legend: {
            enabled: true,
            itemStyle: {
              fontWeight: 'normal'
            }
          },
          credits: {
            enabled: false
          },
          tooltip: {
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormatter: function () {
              var point = this;
              let value = point.y;
              if (this.series.name == "# On Market") {
                return '<tr><td style="color:' + point.color + ';padding:0">' + point.series.name + ': </td><td style="padding:0"><b>' + value + '</b></td></tr>';
              }
              else if (this.series.name == "Avg Cap Rate") {
                return '<tr><td style="color:' + point.color + ';padding:0">' + point.series.name + ': </td><td style="padding:0"><b>' + value + '%</b></td></tr>';
              }
            },
            footerFormat: '</table>',
            shared: true,
            useHTML: true
          },
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0
            }
          },
          series: [{
            name: '# On Market',
            type: 'column',
            data: barChartData,
            color: '#198FDE'

          },
          {
            name: 'Avg Cap Rate',
            data: capRate,
            type: 'spline',
            color: '#003A5D',
            tooltip: {
              valueDecimals: 2
            },
            yAxis: 1
          },
          ]
        }
        Highcharts.chart('BarActiveListingAskingPrice', this.barActiveListingAskingPrice);
      }

      if (reloadType == 0 || reloadType == 3) {
        this.barAskingPriceCapRate = {
          chart: {
            type: 'column',
            height: 400
          },
          title: {
            text: ''
          },
          xAxis: {
            categories: Xaxis,
            crosshair: true
          },
          yAxis: [{
            min: 0,
            title: {
              text: 'Avg. Asking Price'
            },
            allowDecimals: true,
          }, {
            title: {
              text: 'Avg Cap Rate'
            },
            opposite: true,
            labels: {
              format: '{value}%'
            },
            allowDecimals: true,
          }],
          legend: {
            enabled: true,
            itemStyle: {
              fontWeight: 'normal'
            }
          },
          credits: {
            enabled: false
          },
          tooltip: {
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormatter: function () {
              var point = this;
              let value = point.y;
              if (this.series.name == "Avg. Asking Price") {
                value = Math.abs(Number(value)) >= 1.0e+12
                  ? Math.abs(Number(value)) / 1.0e+12 + "T"
                  : Math.abs(Number(value)) >= 1.0e+9
                    ? Math.abs(Number(value)) / 1.0e+9 + "B"
                    : Math.abs(Number(value)) >= 1.0e+6
                      ? Math.abs(Number(value)) / 1.0e+6 + "M"
                      : Math.abs(Number(value)) >= 1.0e+3
                        ? Math.abs(Number(value)) / 1.0e+3 + "K"
                        : Math.abs(Number(value));

                let lastChar = value.toString().charAt(value.length - 1);
                value += '';
                var x = value.split('.');
                var x1 = x[0];
                var x2 = x.length > 1 ? '.' + x[1] : '';
                value = x1 + x2.substr(0, 2) + ((isNaN(lastChar) && value.indexOf('.') > -1) ? lastChar : '');
                return '<tr><td style="color:' + point.color + ';padding:0">' + point.series.name + ': </td><td style="padding:0"><b>$' + value + '</b></td></tr>';
              }
              else if (this.series.name == "Avg Cap Rate") {
                return '<tr><td style="color:' + point.color + ';padding:0">' + point.series.name + ': </td><td style="padding:0"><b>' + value + '%</b></td></tr>';
              }
            },
            footerFormat: '</table>',
            shared: true,
            useHTML: true
          },
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0
            }
          },
          series: [{
            name: 'Avg. Asking Price',
            type: 'column',
            data: barChartAskingPrice,
            color: '#198FDE',

          },
          {
            name: 'Avg Cap Rate',
            data: capRate,
            type: 'spline',
            color: '#003A5D',
            tooltip: {
              valueDecimals: 2
            },
            yAxis: 1
          },
          ]
        }
        Highcharts.chart('BarAskingPriceCapRate', this.barAskingPriceCapRate);
      }

      if (reloadType == 0 || reloadType == 4) {
        this.barRemainingTermCapRate = {
          chart: {
            type: 'column',
            height: 400
          },
          title: {
            text: ''
          },
          xAxis: {
            categories: Xaxis,
            crosshair: true
          },
          yAxis: [{
            min: 0,
            title: {
              text: 'Remaining Term'
            },
            allowDecimals: true,
          }, {
            title: {
              text: 'Avg Cap Rate'
            },
            opposite: true,
            labels: {
              format: '{value}%'
            },
            allowDecimals: true,
          }],
          legend: {
            enabled: true,
            itemStyle: {
              fontWeight: 'normal'
            }
          },
          credits: {
            enabled: false
          },
          tooltip: {
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormatter: function () {
              var point = this;
              let value = point.y;
              if (this.series.name == "Remaining Term") {
                return '<tr><td style="color:' + point.color + ';padding:0">' + point.series.name + ': </td><td style="padding:0"><b>' + value + '</b></td></tr>';
              }
              else if (this.series.name == "Avg Cap Rate") {
                return '<tr><td style="color:' + point.color + ';padding:0">' + point.series.name + ': </td><td style="padding:0"><b>' + value + '%</b></td></tr>';
              }
            },
            footerFormat: '</table>',
            shared: true,
            useHTML: true
          },
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0
            }
          },
          series: [{
            name: 'Remaining Term',
            type: 'column',
            data: remainingTerm,
            color: '#198FDE'

          },
          {
            name: 'Avg Cap Rate',
            data: capRate,
            type: 'spline',
            color: '#003A5D',
            tooltip: {
              valueDecimals: 2
            },
            yAxis: 1
          },
          ]
        }
        Highcharts.chart('BarRemainingTermCapRate', this.barRemainingTermCapRate);
      }

      this.Loader.display(false);
    });
  }

  setFilters() {
    this.chartInput.PropertyId = 0;
    this.chartInput.States = this.selectedStatesList;

    this.chartInput.PropertyTypes = [];
    if (this.chartInput.PropertyType == 0) {
      this.propertyTypesList.filter(x => x.Id > 0).forEach(item => {
        this.chartInput.PropertyTypes.push(item.Id);
      });

    }
    else {
      this.chartInput.PropertyTypes.push(this.chartInput.PropertyType);
    }

    if (this.subCategoriesList) {
      if (this.subCategoriesList.length > 0 && this.chartInput.Subcategory < 0) {
        this.chartInput.Subcategory = 0;
      }
      else if (this.subCategoriesList.length == 1) {
        this.chartInput.Subcategory = this.subCategoriesList[0]["Id"];
      }

      if (!this.chartInput.Subcategory) {
        this.chartInput.Subcategory = 0;
      }
    }

    if (this.subCategoriesList) {
      if (this.subCategoriesList.length > 0 && this.chartInput.Subcategory < 0) {
        this.chartInput.Subcategory = 0;
      }
    }

    this.chartInput.Subcategories = [];
    if (this.chartInput.Subcategory == 0) {
      this.subCategoriesList.filter(x => x.Id > 0).forEach(item => {
        this.chartInput.Subcategories.push(item.Id);
      });
    }
    else if (this.chartInput.Subcategory > 0) {
      this.chartInput.Subcategories.push(this.chartInput.Subcategory);
    }
    else if (this.chartInput.Subcategory < 0) {
      this.chartInput.Subcategories.push(0);
    }
  }

  bindBarPropertyTypeToSubcategory() {

  }
  tenantBreakdown = [];
  showTenantBreakdown = false;
  noSubCategory = false;
  bindTenantBreakdown() {
    this.setFilters();
    if (this.subCategoriesList.length > 0) {
      this.Analytics.GetTenantBreakdown(this.chartInput).subscribe(response => {
        this.tenantBreakdown = response;
        if (this.chartInput.Subcategory >= 0) {
          this.noSubCategory = false;
        }
        else {
          this.noSubCategory = true;
        }
        this.showTenantBreakdown = true;
      });
    }
    else {
      this.showTenantBreakdown = false;
    }
  }

  marketDatatSummary = [];
  marketDatatSummaryTotal = [];
  bindMarketDatatSummary() {
    this.Loader.display(true);
    this.setFilters();
    let input = this.chartInput;
    input.PropertyType = this.selectedPropertyType;
    this.marketDatatSummary = [];
    this.marketDatatSummaryTotal = [];
    this.Analytics.GetMarketDatatSummary(input).subscribe(response => {
      this.marketDatatSummary = response.filter(x => x["RowNumber"] == 1);
      if (this.marketDatatSummary.length > 0) {
        this.marketDatatSummaryTotal = response.filter(x => x["RowNumber"] == 2);
      }
      this.Loader.display(false);
    });
  }
  applyTDStyle(rowindex, columnName) {
    if (this.tenantBreakdown.length <= 1) {
      return;
    }
    let item = this.tenantBreakdown.find(x => x["RowNumber"] == rowindex);
    if (item) {
      return (this.tenantBreakdown.findIndex(x => x[columnName] > item[columnName]) > -1) ? '' : 'highlight-td';
    }
  }
  getTenantBreakdownValues(rowindex, columnName, prefix = '', suffix = '', noFormatting = false) {
    let item = this.tenantBreakdown.find(x => x["RowNumber"] == rowindex);
    if (item) {
      if (noFormatting) {
        return prefix + (item[columnName] < 0 ? 0 : item[columnName]) + suffix;
      }
      else {
        return prefix + this.Validation.commaFormat(item[columnName] < 0 ? 0 : item[columnName]) + suffix;
      }
    }
    else {
      return '-'
    }
  }

  bindSubcategoryContribution() {
    this.setFilters();
    this.chartInput.Mode = this.isSCActiveListing ? 1 : 2;

    this.Analytics.GetSubcategoryDistribution(this.chartInput).subscribe(response => {
      let data = response;

      let subcategoryList = [];
      let AvgPrice = [];
      let Contribution = [];
      data.forEach(item => {
        subcategoryList.push(item["Name"]);
        if (this.isSCActiveListing) {
          AvgPrice.push(item["ActiveListing"]);
        }
        else {
          AvgPrice.push(item["AvgPrice"]);
        }

        Contribution.push(item["Contribution"]);
      });

      let chartHeight = 200;
      chartHeight = chartHeight + (data.length * 30);

      this.barSubcategory = {
        chart: {
          type: 'bar',
          height: chartHeight
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: subcategoryList,
        },
        yAxis: [{
          min: 0,
          title: {
            text: this.isSCActiveListing ? 'Number of Listing' : 'Avg. Asking Price'
          },
          allowDecimals: this.isSCActiveListing ? false : true,
        }, {
          title: {
            text: 'Contribution % to total'
          },
          labels: {
            format: '{value}%'
          },
          allowDecimals: true,
          opposite: true
        }],
        legend: {
          shadow: false
        },
        credits: {
          enabled: false
        },
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormatter: function () {
            var point = this;
            let value = point.y;
            if (this.series.name == "Number of Listing") {
              return '<tr><td style="color:' + point.color + ';padding:0">' + point.series.name + ': </td><td style="padding:0"><b>' + value + '</b></td></tr>';
            }
            else if (this.series.name == "Avg. Asking Price") {
              value = Math.abs(Number(value)) >= 1.0e+12
                ? Math.abs(Number(value)) / 1.0e+12 + "T"
                : Math.abs(Number(value)) >= 1.0e+9
                  ? Math.abs(Number(value)) / 1.0e+9 + "B"
                  : Math.abs(Number(value)) >= 1.0e+6
                    ? Math.abs(Number(value)) / 1.0e+6 + "M"
                    : Math.abs(Number(value)) >= 1.0e+3
                      ? Math.abs(Number(value)) / 1.0e+3 + "K"
                      : Math.abs(Number(value));

              let lastChar = value.toString().charAt(value.length - 1);
              value += '';
              var x = value.split('.');
              var x1 = x[0];
              var x2 = x.length > 1 ? '.' + x[1] : '';
              value = x1 + x2.substr(0, 2) + ((isNaN(lastChar) && value.indexOf('.') > -1) ? lastChar : '');
              return '<tr><td style="color:' + point.color + ';padding:0">' + point.series.name + ': </td><td style="padding:0"><b>$' + value + '</b></td></tr>';
            }
            else {
              return '<tr><td style="color:' + point.color + ';padding:0">' + point.series.name + ': </td><td style="padding:0"><b>' + value + '%</b></td></tr>';
            }
          },
          footerFormat: '</table>',
          shared: true,
          useHTML: true
        },
        plotOptions: {
          bar: {
            grouping: false,
            shadow: false,
            borderWidth: 0,
          },
        },
        series: [{
          name: 'Contribution % to total',
          color: '#003A5D',
          data: Contribution,
          tooltip: {
            valueSuffix: ' %'
          },
          pointWidth: 25,
          pointPadding: 0.3,
          pointPlacement: 0.2,
          yAxis: 1
        }, {
          name: this.isSCActiveListing ? 'Number of Listing' : 'Avg. Asking Price',
          color: '#198FDE',
          data: AvgPrice,
          tooltip: {
            valuePrefix: '$',
          },
          pointWidth: 12,
          pointPadding: 0.4,
          pointPlacement: 0.2,
        }]
      }

      Highcharts.chart('BarSubcategoryContribution', this.barSubcategory);
      this.Loader.display(false);
    });
  }

  chartValidation(excludeDateValidation = false) {
    if (!excludeDateValidation) {
      if (this.Validation.IsinValid(this.chartInput.StartDate) || this.Validation.IsinValid(this.chartInput.EndDate)) {
        this.setCurrentDates();
      }

      if (this.chartInput.StartDate.setHours(0, 0, 0, 0) < this.minDate.setHours(0, 0, 0, 0)) {
        this.Toast.addToast({ title: 'Error Occurred', msg: 'Start Date should not be lesser than Minumum Date', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        return false;
      }

      if (this.chartInput.StartDate.setHours(0, 0, 0, 0) > this.maxDate.setHours(0, 0, 0, 0)) {
        this.Toast.addToast({ title: 'Error Occurred', msg: 'Start Date should not be greater than Maximum Date', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        return false;
      }

      if (this.chartInput.EndDate.setHours(0, 0, 0, 0) < this.minDate.setHours(0, 0, 0, 0)) {
        this.Toast.addToast({ title: 'Error Occurred', msg: 'End Date should not be lesser than Minumum Date', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        return false;
      }

      if (this.chartInput.EndDate.setHours(0, 0, 0, 0) > this.maxDate.setHours(0, 0, 0, 0)) {
        this.Toast.addToast({ title: 'Error Occurred', msg: 'End Date should not be greater than Maximum Date', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        return false;
      }

      if (this.chartInput.StartDate.setHours(0, 0, 0, 0) > this.chartInput.EndDate.setHours(0, 0, 0, 0)) {
        this.Toast.addToast({ title: 'Error Occurred', msg: 'Start Date should not be greater than End Date', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        return false;
      }
      else if (!this.Validation.IsDate(this.chartInput.StartDate) || !this.Validation.IsDate(this.chartInput.EndDate)) {
        this.Toast.addToast({ title: 'Error Occurred', msg: 'Invalid date selected', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        return false;
      }
    }

    this.PropertyTypeText = this.propertyTypesList.find(x => x.Id == this.chartInput.PropertyType)["Name"];
    let find = this.subCategoriesList.find(x => x.Id == this.chartInput.Subcategory);
    if (find) {
      this.SubcategoryText = find["Name"];
    }
    else {
      this.SubcategoryText = '';
    }
    return true;
  }

  bindBarChart(event) {
    if (this.chartValidation()) {
      this.Loader.display(true);
      if (event) {
        this.isActiveListing = !event.target.checked;
      }
      this.bindBarActiveListingAskingPrice();

    }
    else {
      this.Validation.scrollToElement("divAnalyticsDetails", 200);
      event.target.checked = false;
    }
  }

  bindBarChart2(event) {
    if (this.chartValidation()) {
      this.Loader.display(true);
      if (event) {
        this.isRemainingTerm = !event.target.checked;
      }
      this.bindBarPropertyTypeToSubcategory();
    }
    else {
      this.Validation.scrollToElement("divAnalyticsDetails", 200);
      event.target.checked = false;
    }
  }

  bindBarChartSubcategory(event) {
    console.log(event);
    if (this.chartValidation(true)) {
      this.Loader.display(true);
      if (event) {
        this.isSCActiveListing = !event.target.checked;
      }
      this.bindSubcategoryContribution();
    }
    else {
      this.Validation.scrollToElement("divAnalyticsDetails", 200);
      event.target.checked = false;
    }
  }

  onResetClick() {
    this.chartInput.TenantId = this.tenantList[0].Id;
    this.setDynamicLabels();
    this.tenantSelect(true);
  }
  clearStateSelection() {
    $('#hdn_selectedStates').val('');
    let redirectUrl = this.Validation.changeQueryStringValue("tab", "analytics");
    this.Validation.refreshPage(redirectUrl);
    this.Validation.scrollToElement("divAnalyticsDetails", 90);
  }

  activeTab = Tabs.Listings;
  onTabClick(tab) {
    this.activeTab = tab
    if (tab == 1) {
      this.dtElement.dtInstance.then(x => x.draw());
    }
    if (tab == 2) {
      this.getAllTypeList();
    }
    else if (tab == 3) {
      this.getSavedAnalytics();
    }
  }

  propertyTypeList = [];
  selectedPropertyType = 0;
  getAllTypeList() {
    this.common.getTypeList().subscribe(response => {
      if (response != null && response.length > 0) {
        this.propertyTypeList = response.map(o => { return { id: o.Id, name: o.Type } });
        this.selectedPropertyType = this.propertyTypeList[0].id;
        this.bindMarketDatatSummary();
      }
    });
  }
  onPropertyTypeSelect(event) {
    this.bindMarketDatatSummary();
  }
  propertySearchCriteria(searchParameters: IPropertySearchCriteria) {
    this.autoSelectAll();
    this.selectedProperty = null;
    this.selectedRows = [];
    this.showAnalyticsGraphs = false;
    this.searchCriteria = searchParameters;
    this.searchCriteria.IsExport = false;
    this.searchCriteria.IsLatLongEnabled = true;
    this.searchCriteria.PropertyStatus = [351];
    this.mapInitialization();
    this.setDefaultMapPostions();
    this.markers.forEach(item => {
      item.setIcon(this.markerIcon);
    });
    this.showAnalyzeBtn = true;

    this.tenantList = [];
    this.propertyTypesList = [];
    this.subCategoriesList = [];
    this.savedAnalytics = false;

    this.loadMapAndTableData(this.searchCriteria);
  }
  ngAfterViewInit(): void {
    //this.searchCriteria.IsLatLongEnabled = true;
    this.dtTrigger.next(true);
  }

  @ViewChild('hiddenTable') TABLE: ElementRef;
  title = 'Excel';
  ExportTOExcel() {

    var data = this.selectedRows;
    var input = data.map(o => o.Id);
    const httpHeader = this.Validation.GetAuthHeader();
    this._propertyListingService.GetPropertyInfoForAnalytics(input, true).subscribe(resp => {
      let filenameWithExtension: string = resp.toString();
      let filenameWithoutExtension = filenameWithExtension.toString().split('.')[0];
      this.Validation.downloadExcelFile('/upload/excelfile/' + filenameWithoutExtension, 'Analytics Properties.xlsx');
      this.Loader.display(false);
    });

    ///* generate worksheet */
    //const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.TABLE.nativeElement);
    //const wb: XLSX.WorkBook = XLSX.utils.book_new();
    //XLSX.utils.book_append_sheet(wb, ws, "Properties");

    //XLSX.writeFile(wb, this.tenantName + ' - Analytics Properties.xlsx');
  }
  pdfDownload() {
    $("body").removeClass("open-sidemenu");
    this.Loader.display(true);
    this.selectedDatapoint = true;
    setTimeout(() => {
      var divHeight = $('#divAnalyticAll').height();
      var divWidth = $('#divAnalyticAll').width() + 10;
      var ratio = divHeight / divWidth;
      var docDefinition = {};
      this.selectedDatapoint = true;
      html2canvas(document.querySelector("#divAnalyticAll"), {
        scale: 2,
        height: divHeight,
        width: divWidth,
      }).then(function (canvas) {
        var data = canvas.toDataURL();
        var tenant = $('#tenant :selected').text();
        docDefinition = {
          pageMargins: [55, 5, 5, 20],
          pageSize: {
            width: 870,
            height: 'auto'
          },
          content: [{
            image: data,
            width: 800,
            height: (ratio * 870)
          }]
        };
        pdfMake.createPdf(docDefinition).download(tenant + ' - Analytics.pdf');
      });
    }, 1000);

    setTimeout(() => {
      this.selectedDatapoint = false;
      this.Loader.display(false);
    }, 5000);
  }

  saveAnalytics() {
    if (this.saveAnalyticsInput.Name != '' && this.saveAnalyticsInput.Name != null) {
      this.saveAnalyticsInput.SaveSearchInputModel = {} as ISaveSearchInputModel;
      this.saveAnalyticsInput.TenantId = this.chartInput.TenantId;
      this.saveAnalyticsInput.PropertyTypeId = this.chartInput.PropertyType;
      this.saveAnalyticsInput.SubCategoryId = this.chartInput.Subcategory;
      this.saveAnalyticsInput.StartDate = this.chartInput.StartDate;
      this.saveAnalyticsInput.EndDate = this.chartInput.EndDate;
      this.saveAnalyticsInput.IsActiveListing = this.isSCActiveListing;
      this.saveAnalyticsInput.IsMapExpanded = this.expandedMap;
      var data = this.selectedRows;
      this.saveAnalyticsInput.PropertyIds = data.map(o => o.Id);
      this.saveAnalyticsInput.SaveSearchInputModel.PropertySearchCriteria = this.searchCriteria;
      this.user = this.authService.user;
      this._propertyListingService.saveAnalytics(this.saveAnalyticsInput, this.user.Id).subscribe(resp => {
        this.modalRef.hide();
        this._toastService.addToast({ title: 'Success', msg: 'Saved Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });

      });
    }
    else {
      this.isAnalyzeName = true;
    }
  }

  getSavedAnalytics() {
    this._propertyListingService.getSavedAnalytics(this.user.Id).subscribe(resp => {
      this.savedAnalyticsData = resp;
    });
  }
  showAnalytics(guid: string) {
    this.router.navigateByUrl("redirect?url=" + encodeURIComponent("/analytics?Guid=" + guid));
  }

  goBack() {
    this._location.go('analytics');
    this.onTabClick(3);
    this.savedAnalytics = false;
    this.clearSaved = true;
  }

  deleteSavedAnalytics() {
    this._propertyListingService.deleteSavedAnalytics(this.DeleteGuid).subscribe(resp => {
      if (resp) {
        this._toastService.addToast({ title: 'Success', msg: 'Deleted Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        this.getSavedAnalytics();
        this.modalRefDelete.hide();
        this.DeleteGuid = null;
      }
    });
  }

  openDeleteModal(template: TemplateRef<any>, classes: any, guid: string) {
    this.DeleteGuid = guid;
    this.modalRefDelete = this.modalService.show(template, { class: classes });
  }
}
